import { useState, useCallback } from 'react';

/**
 * useSelect hook
 * Helps easily select a value from a list of values
 *
 * @param list List of values to select a value from
 * @param {number} initialIndex Initial index which is selected
 * @returns handler
 * @see https://rooks.vercel.app/docs/useSelect
 */
function useSelect(list, initialIndex = 0) {
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);
    const setItem = useCallback((item) => {
        setSelectedIndex(list.indexOf(item));
    }, [list]);
    return {
        index: selectedIndex,
        item: list[selectedIndex],
        setIndex: setSelectedIndex,
        setItem,
    };
}

export { useSelect };
